// extracted by mini-css-extract-plugin
module.exports = {"card":"addHardware_card__2Mn9N","headingDiv":"addHardware_headingDiv__UiCXV","headingInvite":"addHardware_headingInvite__bZdb9","bottonDiv":"addHardware_bottonDiv__3Pmj-"};